export default __webpack_public_path__ + "static/bo-58bc022a1ab8c4668bc4145a7f068069.svg";